import React, { useRef, useEffect, useState } from "react";
import classNames from "classnames";
import * as c from "./homepageOneColumn.module.scss";
import { Button } from "@components/shared/button";
import { useSlideEnterAnimation } from "@hooks/useSlideEnterAnimation";
import { gsap } from "gsap";
import { throttle } from "@utils/throttle";

const HomepageOneColumn = () => {
  useSlideEnterAnimation();
  const containerRef = useRef(null);
  const cursorRef = useRef(null);

  useEffect(() => {
    const container = cursorRef.current;
    let mm = gsap.matchMedia();
    mm.add("(min-width: 992px)", () => {
      gsap.set(containerRef.current, { "--top": "0px" });
      gsap
        .timeline({
          paused: true,
          scrollTrigger: {
            trigger: containerRef.current,
            start: () => "top 100%+=100px",
            end: () => "top 0%",
            invalidateOnRefresh: true,
            scrub: 0.25,
          },
        })
        .to(containerRef.current, { "--top": "-600px", duration: 100 });
    });

    const cursorFollow = (e) => {
      if (!cursorRef.current) return;

      const containerRect = container.getBoundingClientRect();
      const scrollLeft = container.scrollLeft;
      const scrollTop = container.scrollTop;

      let x = e.clientX - containerRect.left + scrollLeft;
      let y = e.clientY - containerRect.top + scrollTop;

      x = Math.max(0, Math.min(x, container.scrollWidth - 300));
      y = Math.max(0, Math.min(y, container.scrollHeight - 300));

      cursorRef.current.style.setProperty("--x", `${x}px`);
      cursorRef.current.style.setProperty("--y", `${y}px`);
    };

    // Throttle the mousemove event to limit the number of times it fires
    const throttledCursorFollow = throttle(cursorFollow, 100);
    document.addEventListener("mousemove", throttledCursorFollow);
    return () => {
      document.removeEventListener("mousemove", throttledCursorFollow);
      mm.revert();
    };
  }, []);

  return (
    <section className={c.container} ref={containerRef}>
      <div className={classNames(c.gradient)} ref={cursorRef}></div>
      <div className={c.content} data-transition="slide-enter">
        <div data-transition="slide-enter-child" className={c.contentWrapper}>
          <p className={classNames(c.eyebrow, "eyebrow")}>WHY WE’RE DIFFERENT</p>
          <h2 className={classNames(c.title, "h1")}>Salon and spa software, finally done right</h2>
          <p className={classNames(c.description, "p2")}>
            Let’s be real, most salon and spa software isn’t very good. Ugly design, slow speeds, interfaces that get in
            the way. We’re taking a new approach and bringing modern tools to salons and spas.
          </p>
        </div>
        <div className={c.btnwrap} data-transition="slide-enter">
          <Button className={c.button} linkTo="/why-mangomint/" size="large">
            Learn why we're different
          </Button>
        </div>
      </div>
    </section>
  );
};

export { HomepageOneColumn };
